<kilowant-header [isSeller]="true" title="Batches"></kilowant-header>
<div class="form seller">
   <div class="card mt-20">
        <div class="body">
            <table mat-table [dataSource]="dataSource" matSort matSortActive="DateEntered" matSortDirection="desc" matSortDisableClear class="offer-summmary-table">
                <ng-container matColumnDef="#">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let element,let i =index">{{i+1}}</td>
                </ng-container>
                <ng-container matColumnDef="BatchId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>
                <ng-container matColumnDef="DateEntered">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Added</th>
                    <td mat-cell *matCellDef="let element"> {{element.dateEntered | date:'shortDate'}} </td>
                </ng-container>
                <ng-container matColumnDef="Action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let element,let i = index">
                        <a class="link f18" (click)="getBatchExportFile(element.id)">
                            <mat-icon class="customIcons">download_outline</mat-icon>
                        </a>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [hidePageSize]="true" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
        </div>
   </div>
</div>